function Operators(props) {
  return (
    <div>
      <h2>Operators</h2>
    </div>
  );
}

export default Operators;
